const baskets = [
  {
    id: 1,
    images: [
      "https://i.ibb.co/68phjS6/Photo-Room-000-20230115-194750.png",
      "https://i.ibb.co/xS8fNVY/Photo-Room-001-20230115-194750.png",
      "https://i.ibb.co/Q6WHL2k/Photo-Room-002-20230115-194750.png",
      "https://i.ibb.co/gPRfzCs/Photo-Room-003-20230115-194750.png",
      "https://i.ibb.co/N2CnLfw/1.png",
    ],
    code: "СЛ-1р",
    price: "20",
    size: "95x63",
  },
  {
    id: 2,
    images: [
      "https://i.ibb.co/82LQtjK/Photo-Room-001-20230115-232134.png",
      "https://i.ibb.co/khBV8KL/Photo-Room-000-20230115-232134.png",
      "https://i.ibb.co/VmQWbjr/Photo-Room-009-20230124-230341.png",
    ],
    code: "СЛ-2р",
    price: "22",
    size: "100x63",
  },
  {
    id: 3,
    images: [
      "https://i.ibb.co/zxL26q3/Photo-Room-002-20230115-232134.png",
      "https://i.ibb.co/1bNvW44/Photo-Room-013-20230124-230341.png",
      "https://i.ibb.co/d5zHqXx/2.png",
    ],
    code: "СЛ-2р (ант)",
    price: "29",
    size: "100x63",
  },
  {
    id: 4,
    images: [
      "https://i.ibb.co/YB3wXF7/Photo-Room-011-20230124-230341.png",
      "https://i.ibb.co/WWftmMT/Photo-Room-010-20230124-230341.png",
      "https://i.ibb.co/0JTvKxd/Photo-Room-012-20230124-230341.png",
    ],
    code: "СЛ-н/б",
    price: "33",
    size: "100x65",
  },
  {
    id: 5,
    images: [
      "https://i.ibb.co/WnMC5LG/1.png",
      "https://i.ibb.co/Bqjg35D/1-2.png",
      "https://i.ibb.co/68qxwdL/1-3.png",
      "https://i.ibb.co/T0ttxKH/1-4.png",
    ],
    code: "СЛ-1р в (лтс)",
    price: "30",
    size: "115x63",
  },
  {
    id: 6,
    images: [
      "https://i.ibb.co/0tTJmqd/image.png",
      "https://i.ibb.co/bWM50C2/2.png",
      "https://i.ibb.co/yWTxNV8/3.png",
      "https://i.ibb.co/FYnB26M/4.png",
    ],
    code: "СЛ-н/б с лилиями",
    price: "50",
    size: "116x70",
  },
  {
    id: 7,
    images: ["https://i.ibb.co/NFXjYH8/Photo-Room-000-20240421-235423.png"],
    code: "СЛ-1р в (роз)",
    price: "55",
    size: "115x63",
  },
  {
    id: 8,
    images: ["https://i.ibb.co/sdtStc76/photo-2026-02-09-17-31-59.jpg"],
    code: "К-23",
    price: "",
    size: "",
  },
  {
    id: 9,
    images: [
      "https://i.ibb.co/mCWgsM4j/photo-2026-02-09-17-32-00.jpg",
      "https://i.ibb.co/msnbq0T/photo-2026-02-09-17-32-01.jpg",
      "https://i.ibb.co/xtyMJQk7/photo-2026-02-09-17-32-03.jpg",
      "https://i.ibb.co/NRdPW7B/photo-2026-02-09-17-32-04.jpg",
    ],
    code: "Ваза",
    price: "",
    size: "",
  },
  {
    id: 10,
    images: ["https://i.ibb.co/x8tNYNMZ/photo-2026-02-09-17-32-05.jpg"],
    code: "Корз. 1",
    price: "",
    size: "",
  },
  {
    id: 11,
    images: ["https://i.ibb.co/v66VR3hC/photo-2026-02-09-17-32-06.jpg"],
    code: "Корз. 2",
    price: "",
    size: "",
  },
  {
    id: 12,
    images: ["https://i.ibb.co/DjjbsWT/photo-2026-02-09-17-32-08.jpg"],
    code: "Корз. 3",
    price: "",
    size: "",
  },
  {
    id: 13,
    images: ["https://i.ibb.co/xqjBrBgk/photo-2026-02-09-17-32-10.jpg"],
    code: "Корз. 4",
    price: "",
    size: "",
  },
  {
    id: 14,
    images: ["https://i.ibb.co/v4GB8JZp/photo-2026-02-09-17-32-11.jpg"],
    code: "Корз. 5",
    price: "",
    size: "",
  },
  {
    id: 15,
    images: ["https://i.ibb.co/sJymdDK9/photo-2026-02-09-17-28-13.jpg"],
    code: "Корз. 6",
    price: "",
  },
  {
    id: 15,
    images: ["https://i.ibb.co/zHSdCtRN/photo-2026-02-23-15-04-02.jpg"],
    code: "Корз. 7",
    price: "",
  },
  {
    id: 16,
    images: ["https://i.ibb.co/HDnnFy2g/photo-2026-02-23-15-04-03.jpg"],
    code: "Корз. 8",
    price: "",
  },
  {
    id: 17,
    images: ["https://i.ibb.co/LdPyQsb6/photo-2026-02-23-15-04-04.jpg"],
    code: "Корз. 9",
    price: "",
  },
  {
    id: 18,
    images: ["https://i.ibb.co/1twWv72F/photo-2026-02-23-15-04-05.jpg"],
    code: "Корз. 10",
    price: "",
  },
  {
    id: 19,
    images: ["https://i.ibb.co/ksJtKz4S/photo-2026-02-23-15-04-06.jpg"],
    code: "Корз. 11",
    price: "",
  },
  {
    id: 20,
    images: ["https://i.ibb.co/tp7FyRYj/photo-2026-02-23-15-04-07.jpg"],
    code: "Корз. 12",
    price: "",
  },
  {
    id: 21,
    images: ["https://i.ibb.co/4w0pvMtD/photo-2026-02-23-15-04-32.jpg"],
    code: "Корз. 13",
    price: "",
  },
  {
    id: 22,
    images: ["https://i.ibb.co/TxN8NyT0/photo-2026-03-04-17-22-58.jpg"],
    code: "Корз. 14",
    price: "",
  },
];

export default baskets;
